import {ProjectService} from '../project.service';
import {Observable, of} from 'rxjs';
import {Project, ProjectSearchResponse} from '../../models/project';

export const mockProjects: Project[] = [
    {
        id: 1,
        name: 'Test Project 1',
        code: '10001',
        city: 'Enschede',
        endDate: new Date(),
        companyName: 'Recognize',
        imageUrl: 'https://projectenportaal.acc.volkerwessels.dev/blob/00ccc455-2033-44d8-9e13-8f288fc2d5e5',
        commercialProjectName: '',
        kvwNumber: '0001'
    },
    {
        id: 2,
        name: 'Test Project 2',
        code: '10002',
        city: 'Almelo',
        endDate: new Date(),
        companyName: 'Recognize',
        imageUrl: 'https://projectenportaal.acc.volkerwessels.dev/blob/013bb535-9ca5-4f28-b825-30e2c7ad3282',
        commercialProjectName: 'BVGO Project commerciele naam',
        kvwNumber: '0001'
    },
    {
        id: 3,
        name: 'BVGO Project',
        code: '10003',
        city: 'Osnabrueck',
        endDate: new Date(),
        companyName: 'BVGO',
        imageUrl: 'https://projectenportaal.acc.volkerwessels.dev/blob/013bb535-9ca5-4f28-b825-30e2c7ad3282',
        commercialProjectName: '',
        kvwNumber: '0002'
    },
];

export class ProjectServiceMock implements ProjectService {

    searchProjectsWithoutReference(search: string): Observable<ProjectSearchResponse[]> {
        return of((mockProjects.filter(project => {
            return !project.reference &&
                (
                    project.code.toLowerCase().includes(search.toLowerCase()) ||
                    project.city.toLowerCase().includes(search.toLowerCase()) ||
                    project.name.toLowerCase().includes(search.toLowerCase())
                );
        })));
    }

}
